/* eslint-disable import/no-cycle */
import { func, number, shape, string } from 'prop-types';
import React from 'react';
import DoubleScrollBar from 'react-double-scrollbar';

import { campaignShape } from '../../prop-types';
import { productAggregatesMapShape } from '../change-product-budget/constants';
import MoveBudgetToWalletTable from './MoveBudgetToWalletTable';

function MoveBudgetToWalletForm({ value, onChange, campaign }) {
  const { productAggregates: productAggregatesMap, delta } = value;
  return (
    <DoubleScrollBar>
      <MoveBudgetToWalletTable
        productAggregatesMap={productAggregatesMap}
        delta={delta}
        onChange={onChange}
        campaign={campaign}
      />
    </DoubleScrollBar>
  );
}

MoveBudgetToWalletForm.propTypes = {
  onChange: func.isRequired,
  campaign: campaignShape.isRequired,
  value: shape({
    commercialIncentive: string,
    delta: number.isRequired,
    productAggregates: productAggregatesMapShape.isRequired,
  }).isRequired,
};

export default MoveBudgetToWalletForm;
